<template>
   <section>
      <nav v-if="isLogin" class="navbar navbar-expand-lg navbar-dark navbar-background sticky-top mb-5" >
        <div class="container d-flex justify-content-evenly">
          <div>
            <a class="navbar-brand" href="#">
              <img src="../assets/images/logofix.png" width="25%" height="50%" alt="">
            </a>
          </div>
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ms-auto d-flex justify-content-between menunavbar">
              <li class="nav-item ">
                <router-link  :to="{ name: 'Home' }" class="nav-link align-middle px-0">
                    <a class="nav-link fw-bolder fs-5" >Beranda</a>
                  </router-link>
              </li>
              <li class="nav-item">
                <router-link  :to="{ name: 'ListPuskesmas' }" class="nav-link align-middle px-0">
                    <a class="nav-link fw-bolder fs-5">Daftar Puskesmas</a>
                </router-link>
                <!-- <p>tes</p> -->

              </li>
              <li class="nav-item">
                   <router-link  :to="{ name: 'Statistik' }" class="nav-link align-middle px-0">
                        <a  class="nav-link fw-bolder fs-5" href="">Statistik</a>
                    </router-link>
              </li>
              <li class="nav-item ">
                  <router-link  :to="{ name: 'Login' }" class="nav-link align-middle px-0">
                        <a @click="logout" class="nav-link fw-bolder fs-5" href="">Keluar</a>
                    </router-link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </section>
</template>

<script>
export default {
    name : 'Navbar',
    computed : {
      isLogin(){
        return this.$store.state.isLogin
      }
    },
    methods : {
      logout(){
        localStorage.clear();
        this.$store.commit("SETLOGOUT", false);
        this.$vToastify.success({
          title : 'Berhasil keluar',
          body : 'Silahkan berkunjung kembali',
          theme : 'light'
        });
        // this.$router.push({ name: "Login" });
      }
    }
}
</script>

<style>

</style>